import { initializeApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
import FirebaseConfig from '@/const/FirebaseConfig'

// 기존 FirebaseConfig.ts의 설정을 그대로 사용
const firebaseConfig = FirebaseConfig

let app: FirebaseApp | null = null
let auth: Auth | null = null

// Initialize Firebase only if config is available
export const initFirebase = (): void => {
  if (!app && firebaseConfig.apiKey) {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
  }
}

export const getFirebaseAuth = (): Auth | null => {
  if (!auth) {
    initFirebase()
  }
  return auth
}

export const isFirebaseConfigured = (): boolean => {
  return Boolean(firebaseConfig.apiKey)
}
